import ActionSheet from "actionsheet-react";
import React, { useEffect, useState } from "react";
import { Button } from "react-bootstrap";
import Loader from "react-js-loader";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import backArrow from "../../assets/svgs/backArrow.svg";
import BotSVG from "../../assets/svgs/bot.svg";
import BotInfoSVG from "../../assets/svgs/botInfo.svg";
import DeleteSVG from "../../assets/svgs/delete.svg";
import InfoSVG from "../../assets/svgs/info.svg";
import EditPencilSvg from "../../assets/svgs/pencil.svg";
import SendSVG from "../../assets/svgs/send.svg";
import UserSVG from "../../assets/svgs/user.svg";
import MobileViewLayout from "../../layouts/MobileViewLayout";
import { fetchDemoOpenAi } from "../../redux/actions/demo";
import {
  createNewChat,
  deleteChat,
  updateChatName,
  updateConversation,
} from "../../service/prevChats";
import { addS3Url, isValidArray } from "../../utils/modules";

let timeStamp = null;

const AiChat = () => {
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);
  const [editMode, setEditMode] = useState(false);
  const [input, setInput] = useState("");
  const [conversation, setConversation] = useState([]);

  const dispatch = useDispatch();
  const location = useLocation();
  const navigate = useNavigate();
  const stateObj = location.state;

  const [newChatTitle, setNewChatTitle] = useState(
    stateObj?.name || "New Chat"
  );

  const chatContainerRef = React.useRef();
  const infoSheetRef = React.useRef();
  const delteSessionSheetRef = React.useRef();

  const { chatLoading = false } = useSelector((state) => ({
    chatLoading: state?.demoOpenAi?.loading,
  }));

  const handleResize = () => {
    setWindowWidth(window.innerWidth);
  };

  const openInfoSheet = () => {
    infoSheetRef.current.open();
  };

  const openDeleteSessionSheet = () => {
    delteSessionSheetRef.current.open();
  };

  const onInfoSheetClose = () => {
    if (editMode && stateObj.chatId) {
      updateChatName(stateObj.chatId, newChatTitle);
    }
    setEditMode(false);
  };

  React.useEffect(() => {
    setWindowWidth(window.innerWidth);

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const handleInputChange = (e) => {
    setInput(e.target.value);
    const sendIcon = document.querySelector(".send-icon");
    if (e.target.value) {
      sendIcon?.classList?.add("show");
    } else {
      sendIcon?.classList?.remove("show");
    }
  };

  const sendMessage = async () => {
    if (input.length > 0) {
      const newConversation = [...conversation, { text: input, user: "user" }];
      setConversation(newConversation);
      setTimeout(() => {
        const latest = [...newConversation, { text: "", user: "bot" }];
        setConversation(latest);
        dispatch(fetchDemoOpenAi(stateObj?.desc, input)).then((botResponse) => {
          const updatedConversation = [
            ...newConversation,
            { text: botResponse, user: "bot" },
          ];
          setConversation(updatedConversation);
          updateConversation(
            stateObj.chatId === undefined ? timeStamp : stateObj.chatId,
            updatedConversation
          );
        });
      }, [1000]);
      setInput("");
      const sendIcon = document.querySelector(".send-icon");
      sendIcon?.classList?.remove("show");
      const currentTime = new Date();
      localStorage.setItem(
        "lastChat",
        JSON.stringify({
          title: stateObj?.title,
          desc: stateObj?.desc,
          image: stateObj?.image,
          time: currentTime,
          id: stateObj?.chatId,
          conversation: newConversation,
        })
      );

      if (!stateObj.chatId) {
        createNewChat(
          currentTime,
          stateObj?.title,
          stateObj?.desc,
          stateObj?.image,
          newConversation
        );
        timeStamp = stateObj?.title + currentTime;
      }
    }
  };

  const scrollToBottom = () => {
    if (chatContainerRef.current) {
      chatContainerRef.current.scrollTop =
        chatContainerRef.current.scrollHeight;
    }
  };

  const handleNewChatClick = () => {
    setConversation([]);
    setNewChatTitle("New Chat");
    const currentTime = new Date().getTime();

    localStorage.setItem(
      "lastChat",
      JSON.stringify({
        title: stateObj?.title,
        desc: stateObj?.desc,
        image: stateObj?.image,
        time: currentTime,
        id: stateObj?.title + currentTime,
      })
    );

    const newChat = createNewChat(
      currentTime,
      stateObj?.title,
      stateObj?.desc,
      stateObj?.image
    );

    navigate("/ai/chat", {
      replace: true,
      state: {
        image: stateObj.image,
        title: stateObj.title,
        desc: stateObj.desc,
        time: currentTime.toString(),
        chatId: newChat.id,
      },
    });
    infoSheetRef.current.close();
  };

  useEffect(() => {
    scrollToBottom();
  }, [conversation, chatLoading]);

  React.useEffect(() => {
    stateObj?.conversation && setConversation(stateObj.conversation);
  }, []);

  return (
    <div className="d-flex flex-grow-1 ">
      <MobileViewLayout>
        {" "}
        <>
          <div className="px-3">
            <div
              className="d-flex w-100 justify-content-between align-items-center px-2"
              style={{
                zIndex: 100,
                position: "sticky",
                top: 0,
                backgroundColor: "white",
                left: 200,
                borderBottom: "1px solid #F2F2F2",
                padding: "15px 0px",
              }}
            >
              <div
                onClick={() => {
                  navigate(-1);
                }}
              >
                <img src={backArrow} alt="back" style={{ width: "25px" }} />
              </div>
              <div>
                <h2
                  style={{ fontWeight: 700, fontSize: "27px" }}
                  className="m-0"
                >
                  {newChatTitle || "New Chat"}
                </h2>
              </div>
              <div onClick={openInfoSheet}>
                <img src={InfoSVG} alt="info" style={{ width: "25px" }} />
              </div>
            </div>
            <div
              ref={chatContainerRef}
              style={{
                padding: "10px 0px",
                maxHeight: "max-content",
                height: "80svh",
                overflowY: "auto",
              }}
              className="position-relative scrollbar-hidden px-2"
            >
              <div
                className="d-flex gap-1"
                style={{ paddingTop: "5px", paddingBottom: "15px" }}
              >
                <div style={{ height: "58px" }}>
                  <img
                    alt="AI-BOT"
                    src={stateObj.image || addS3Url("/aiBots/1.png")}
                    style={{ height: "100%" }}
                  />
                </div>
                <p className="fs18 ms-1" style={{ fontWeight: 700 }}>
                  {stateObj?.title || "EmailEngine"}
                </p>
              </div>
              <p
                style={{
                  fontSize: "14px",
                  fontWeight: 600,
                  lineHeight: "18px",
                }}
              >
                {stateObj?.desc ||
                  "EmailEngine specializes in crafting effective email marketing campaigns, providing templates, and analyzing campaign performance."}
              </p>
              <div className="d-flex gap-3 ">
                <Button
                  onClick={openInfoSheet}
                  className="d-flex align-items-center text-black justify-content-center border-0 "
                  style={{
                    padding: "10px 10px",
                    backgroundColor: "#F2F2F2",
                    fontSize: "17px",
                    lineHeight: "19px",
                    fontWeight: 600,
                    borderRadius: "5px",
                    gap: "5px",
                    boxShadow: "none",
                  }}
                >
                  <img src={BotInfoSVG} alt="info" style={{ width: "16px" }} />
                  Bot Info
                </Button>
                {(conversation.length > 0 || stateObj.chatId) && (
                  <Button
                    onClick={openDeleteSessionSheet}
                    className="d-flex align-items-center text-black justify-content-center border-0 "
                    style={{
                      padding: "10px 10px",
                      backgroundColor: "#F2F2F2",
                      fontSize: "17px",
                      lineHeight: "19px",
                      fontWeight: 600,
                      borderRadius: "5px",
                      gap: "5px",
                      boxShadow: "none",
                    }}
                  >
                    <img
                      src={DeleteSVG}
                      alt="delete"
                      style={{ width: "16px" }}
                    />
                    Delete Session
                  </Button>
                )}
              </div>
              <div
                className="d-flex justify-content-center align-items-center scrollbar-hidden"
                style={{
                  marginTop: "20px",
                  height: conversation.length < 1 ? "40dvh" : "",
                }}
              >
                {isValidArray(conversation) ? (
                  <div className="d-flex flex-column w-100">
                    {conversation.map((message, index) => {
                      return (
                        <div
                          className="d-flex flex-row w-100 p-2"
                          key={index}
                          style={{
                            backgroundColor:
                              message.user === "bot" && "#f5f7f9",
                            borderRadius: "5px",
                          }}
                        >
                          <img
                            alt="icon"
                            className="me-3"
                            src={message.user === "user" ? UserSVG : BotSVG}
                            style={{ height: "100%" }}
                          />
                          {chatLoading && message.text === "" ? (
                            <Loader
                              type="bubble-scale"
                              bgColor="#828282"
                              size={30}
                            />
                          ) : (
                            <div className="d-flex flex-column mb-1">
                              {message.text
                                .split("\n\n")
                                .map((paragraph, index) => (
                                  <div key={index}>
                                    {index !== 0 && <br />}
                                    <p className="m-0 p-0">{paragraph}</p>
                                  </div>
                                ))}
                            </div>
                          )}
                        </div>
                      );
                    })}
                  </div>
                ) : (
                  <p
                    className="fs18"
                    style={{ fontWeight: 600, color: "#989898" }}
                  >
                    No Messages yet.
                  </p>
                )}
              </div>
            </div>
            <div
              className="position-absolute chat-input"
              style={{
                bottom: "30px",
                padding: "0px 10px",
                width: "93%",
              }}
            >
              <input
                type="text"
                placeholder="Write a message..."
                className="ai-chat-input w-100"
                value={input}
                onChange={handleInputChange}
              />
              <img
                alt="send"
                src={SendSVG}
                onClick={sendMessage}
                className="send-icon"
              />
            </div>
          </div>
          <ActionSheet
            onClose={onInfoSheetClose}
            className="actionSheet"
            sheetStyle={{
              backgroundColor: "#DBDBDB",
              borderTopLeftRadius: 8,
              borderTopRightRadius: 8,
              maxWidth: "100%",
              margin: "0 auto",
              right: 0,
            }}
            bgStyle={{
              backgroundColor: "transparent",
            }}
            bgTransition="opacity 0.3s ease-in-out"
            sheetTransition="transform 0.3s ease-in-out"
            ref={infoSheetRef}
          >
            <div style={{ backgroundColor: "#DBDBDB", padding: "15px 15px" }}>
              <div className="d-flex gap-2 " style={{ padding: "5px 5px" }}>
                <div>
                  <img
                    alt="AiBot"
                    src={stateObj?.image || addS3Url("/aiBots/1.png")}
                    style={{ height: "58px" }}
                  />
                </div>
                <div className="w-100">
                  {editMode ? (
                    <>
                      <input
                        className="fs18 w-100 border-0"
                        style={{ fontWeight: 700, outline: "none" }}
                        value={newChatTitle}
                        onChange={(e) => setNewChatTitle(e.target.value)}
                      />
                      <p className="m-0">{stateObj?.title}</p>
                    </>
                  ) : (
                    <div className="d-flex justify-content-between align-items-center w-100">
                      <div className="d-flex flex-column">
                        <p className="m-0 fs18" style={{ fontWeight: 700 }}>
                          {editMode
                            ? stateObj?.title
                            : newChatTitle || "New chat"}
                        </p>
                        <p className="m-0">{stateObj?.title}</p>
                      </div>
                      {stateObj.chatId && (
                        <div onClick={() => setEditMode(true)}>
                          <img
                            src={EditPencilSvg}
                            alt="edit"
                            style={{ width: "20px" }}
                          />
                        </div>
                      )}
                    </div>
                  )}
                  {!stateObj?.title && (
                    <p
                      className="m-0"
                      style={{ fontSize: "10px", fontWeight: 650 }}
                    >
                      EmailEngine
                    </p>
                  )}
                </div>
              </div>
              <div style={{ padding: "5px 0px" }}>
                <p
                  className="m-0"
                  style={{
                    fontSize: "12px",
                    fontWeight: 600,
                    lineHeight: "15px",
                  }}
                >
                  {stateObj?.desc ||
                    "EmailEngine specializes in crafting effective email marketing campaigns, providing templates, and analyzing campaign performance."}
                </p>
              </div>
              <div style={{ padding: "5px 0px" }} className="d-flex gap-3">
                <Button
                  style={{
                    borderRadius: "5px",
                    backgroundColor: "#4286F5",
                    border: "none",
                    fontSize: "17px",
                    fontWeight: 650,
                    color: "white",
                  }}
                  onClick={handleNewChatClick}
                >
                  + New Chat
                </Button>
                {conversation.length > 0 && (
                  <Button
                    onClick={openDeleteSessionSheet}
                    className="d-flex align-items-center justify-content-center"
                    style={{
                      borderRadius: "5px",
                      backgroundColor: "#F2F2F2",
                      border: "none",
                      fontSize: "17px",
                      fontWeight: 650,
                      color: "black",
                    }}
                  >
                    <img
                      alt=""
                      src={DeleteSVG}
                      style={{ height: "17px", marginRight: "2px" }}
                    />
                    Delete Session
                  </Button>
                )}
              </div>
            </div>
          </ActionSheet>
          <ActionSheet
            className="actionSheet"
            ref={delteSessionSheetRef}
            bgStyle={{
              backgroundColor: "transparent",
            }}
            sheetStyle={{
              backgroundColor: "#DBDBDB",
              borderTopLeftRadius: 8,
              borderTopRightRadius: 8,
              maxWidth: "100%",
              margin: "0 auto",
              right: 0,
            }}
            bgTransition="opacity 0.3s ease-in-out"
            sheetTransition="transform 0.3s ease-in-out"
          >
            <div
              style={{ backgroundColor: "#DBDBDB", padding: "15px 15px" }}
              className="d-flex flex-column gap-3"
            >
              <h3
                className="text-center m-0 px-2"
                style={{ fontSize: "24px", fontWeight: 650 }}
              >
                Do you want to delete this session?
              </h3>
              <p
                className="text-center m-0 px-2"
                style={{ fontSize: "18px", fontWeight: 600 }}
              >
                Are you sure you want to permanently delete this session?
              </p>
              <div className="d-flex gap-2 w-100">
                <Button
                  onClick={() => {
                    delteSessionSheetRef.current.close();
                  }}
                  className="w-50 py-3"
                  style={{
                    backgroundColor: "#989898",
                    borderRadius: "5px",
                    fontSize: "18px",
                    fontWeight: 600,
                    border: "none",
                  }}
                >
                  Cancel
                </Button>
                <Button
                  onClick={() => {
                    delteSessionSheetRef.current.close();
                    deleteChat(stateObj.chatId);
                    navigate(-1);
                  }}
                  className="w-50 py-3"
                  style={{
                    backgroundColor: "#C40606",
                    borderRadius: "5px",
                    fontSize: "18px",
                    fontWeight: 600,
                    border: "none",
                  }}
                >
                  Delete
                </Button>
              </div>
            </div>
          </ActionSheet>
        </>
      </MobileViewLayout>
    </div>
  );
};

export default AiChat;
